import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './HomePage.css';

// Photos du carrousel héros
import slide1 from '../images/ChefferieBakong.jpg';
import slide2 from '../images/photoCongres5.jpeg';
import slide3 from '../images/photoCongres6.jpeg';
import slide4 from '../images/pointEauCarreleChefferie.jpeg';

function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const handler = (e) => setReduced(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);
  return reduced;
}

function HeroCarousel({ slides }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const reducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (paused || reducedMotion) return undefined;
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(id);
  }, [paused, reducedMotion, slides.length]);

  const goTo = (i) => setIndex((i + slides.length) % slides.length);

  return (
    <div
      className="hero-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="hero-carousel-viewport">
        <div
          className="hero-carousel-track"
          style={{ transform: `translateX(-${index * 100}%)` }}
        >
          {slides.map((slide) => (
            <div className="hero-slide" key={slide.image}>
              <p className="hero-slide-caption">{slide.message}</p>
              <img src={slide.image} alt={slide.message} />
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        className="hero-carousel-arrow hero-carousel-arrow-prev"
        onClick={() => goTo(index - 1)}
        aria-label="Photo précédente"
      >
        ‹
      </button>
      <button
        type="button"
        className="hero-carousel-arrow hero-carousel-arrow-next"
        onClick={() => goTo(index + 1)}
        aria-label="Photo suivante"
      >
        ›
      </button>

      <div className="hero-carousel-dots" role="tablist" aria-label="Sélection de la photo">
        {slides.map((slide, i) => (
          <button
            key={slide.image}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Aller à la photo ${i + 1}`}
            className={`hero-carousel-dot ${i === index ? 'is-active' : ''}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>
    </div>
  );
}

export default function HomePage() {
  const { t } = useTranslation();

  const slides = [
    { image: slide1, message: t('menu.homeHeroSlide1') },
    { image: slide2, message: t('menu.homeHeroSlide2') },
    { image: slide3, message: t('menu.homeHeroSlide3') },
    { image: slide4, message: t('menu.homeHeroSlide4') },
  ];

  return (
    <div className="home-container">
      <HeroCarousel slides={slides} />

      <section className="preamble-section">
        <div className="preamble-title-band">
          <h2>{t('menu.homePreambleTitle')}</h2>
        </div>
        <div className="preamble-content">
          <p>{t('menu.homePreambleText1')}</p>
          <p className="preamble-intro">{t('menu.homePreambleIntro')}</p>
          <ul>
            <li>{t('menu.homePreambleBullet1')}</li>
            <li>{t('menu.homePreambleBullet2')}</li>
            <li>{t('menu.homePreambleBullet3')}</li>
          </ul>
        </div>
      </section>
    </div>
  );
}
